// v1.28.54 — Single source of truth for capturing the "back to where I was"
// URL that Quick-Action deep links (Cash / Payout / Uploads) pass through
// their `?back=…` query param.
//
// Historically `AdminLayout.jsx`'s ActionPill read from React Router's
// `useLocation()` while `QuickActionsFab.jsx` read from `window.location`.
// The two could disagree during route transitions, and when the admin
// clicked Record Payment from a party ledger the back URL sometimes came
// through as `/admin` instead of `/admin/reports?party=…` — leaving the
// user stranded on the main dashboard after saving. Both call sites now
// share this helper so a future fix can't update one and miss the other.

/**
 * Reads the current path + search from `window.location`. Falls back to
 * empty string if invoked in a non-browser context (SSR, tests).
 */
export function captureBackUrl() {
    if (typeof window === "undefined" || !window.location) return "";
    return window.location.pathname + (window.location.search || "");
}

/**
 * Convenience: appends the encoded back URL to a target path.
 * Handles both "/admin?open=cash" and "/admin/uploads" (with/without existing query).
 */
export function withBackParam(target) {
    const back = captureBackUrl();
    if (!back) return target;
    const sep = target.includes("?") ? "&" : "?";
    return `${target}${sep}back=${encodeURIComponent(back)}`;
}
